import { gql } from 'graphql-request';

const FaqFragment = gql`
  fragment Faq on FAQBlock {
    title
    faqItems {
      ... on FAQItemBlock {
        question
        answer
      }
    }
  }
`;
export default FaqFragment;
